// extracted by mini-css-extract-plugin
module.exports = {"list":"_3Ozv5","item":"yk2Ry","link":"av5ZI","alignLeft":"_373Fs","alignCenter":"_2c897","alignRight":"_30a5-","text":"_3Q0sv","message":"w6GE3"};